import { resolveVersion as resolveVersionWithPrefix } from '@xlearn/version-info'
export { VersionInfo } from '@xlearn/version-info'


export function resolveVersion() {
  const prefix = 'VUE_APP_'
  return resolveVersionWithPrefix(prefix)
}
